import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Promise from 'bluebird';
import pageContext from '@bingads-webui-static-legacy/page-context';
import ViewModel from '@bingads-webui-campaign-legacy/advanced-settings/viewmodel/advancedSettings';
import tmpl from '@bingads-webui-campaign-legacy/advanced-settings/template/advancedSettings.pug';
import urlOptionsTemplate from '@bingads-webui-campaign-legacy/advanced-settings/template/url-options.pug';
import '@bingads-webui-campaign/ko-stop-binding';
import BaseTargetUpdateView from '@bingads-webui-campaign-legacy/base-targets/view/baseUpdate';
import LocationTargetBidView from '@bingads-webui-campaign-legacy/location-targets/view/locationTargetBid';
import * as locationTargetTypes from '@bingads-webui-campaign-legacy/location-targets/util/locationTargetTypes';
import AdScheduleView from '@bingads-webui-campaign-legacy/ad-schedule/view/index';
import targetTypes from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetTypes';
import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';
import * as criterionLoader from '@bingads-webui-campaign-legacy/base-targets/util/criterionLoader';
import currentCampaignType from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/campaignType';
import UpgradedUrlOptions from '@bingads-webui-component-legacy/upgraded-url/view/advancedSettingsUrlOptions';
import AdRotationView from '@bingads-webui-campaign-legacy/advanced-settings/view/ad-rotation';
import AdDistributionView from '@bingads-webui-campaign-legacy/advanced-settings/view/ad-distribution';
import BaseExclusionView from '@bingads-webui-campaign-legacy/advanced-settings/view/base-exclusion';
import exclusionRepository from '@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import AutomatedCTAView from '@bingads-webui-campaign-legacy/advanced-settings/view/automated-cta';
import { VanityUrlOption } from '@bingads-webui-campaign-react/vanity-url-option';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const scenarioToSectionsMap = {
  'creation-workflow': ['PredictiveMatching', 'LocationTargets', 'DeviceTargets', 'AdSchedule', 'NativeAds', 'DateSettings', 'AdDistribution', pageContext.Permissions.IsMultiMediaAdsEnabled && 'MultimediaAds'],
  'shopping-creation-workflow': ['DeviceTargets', 'AdSchedule', 'DateSettings', 'AdDistribution'],
  'campaign-settings': ['PredictiveMatching', 'DeviceTargets', 'AgeTargets', 'GenderTargets', 'NativeAds', 'AdSchedule', 'UrlOptions', 'SiteExclusion', 'IPExclusion', 'VanityUrlSettings', pageContext.Permissions.IsMultiMediaAdsEnabled && 'MultimediaAds'],
  'adgroup-create': ['DeviceTargets', 'AdSchedule', 'NativeAds', 'DateSettings', 'AdDistribution', pageContext.Permissions.IsMultiMediaAdsEnabled && 'MultimediaAds'],
  'adgroup-settings': ['DeviceTargets', 'AgeTargets', 'GenderTargets', 'NativeAds', 'AdSchedule', 'UrlOptions', 'AdRotation', 'DateSettings', 'AdDistribution', 'SiteExclusion', pageContext.Permissions.IsMultiMediaAdsEnabled && 'MultimediaAds'],
  'smart-shopping-campaign': ['UrlOptions'],
};

_.each(scenarioToSectionsMap, (sections, scenario) => {
  scenarioToSectionsMap[scenario] = _.compact(sections);
});

const defaultPopupIds = {
  AdSchedule: 'pop_BA_Targeting_DayTime',
  BidAdjustment: 'Page_TargetByDayTime_BidAdjustment',
  TimeZone: 'pop_BA_Targeting_TimeZone',
};

export default class View extends Backbone.View {
  initialize({
    campaignId = '',
    adgroupId = '',
    level = 'campaign',
    scenario = 'creation-workflow',
    nativeAdsCampaignBid = null,
    nativeAdsAdgroupBid = null,
    multimediaAdsCampaignBid = null,
    multimediaAdsAdgroupBid = null,
    model = {},
    TimeZone = '',
    campaignType = 'search',
    campaignSubType = null,
    language = '',
    languages = [],
    campaignBiddingStrategy = '',
    campaignAdScheduleUseSearcherTimeZone = null,
    collapseAdvancedSettings = false,
    activityLogger,
    supportCashbackSettings = false,
    isSPBCampaign = false,
    isMSStoreAdsGAWorkflow = false,
    popupIds = {},
    newI18n,
  }) {
    this.campaignId = campaignId;
    this.adgroupId = adgroupId;
    this.level = level;
    this.scenario = scenario;
    this.scenarioToSectionsMap = scenarioToSectionsMap;
    this.nativeAdsAdgroupBid = nativeAdsAdgroupBid;
    this.nativeAdsCampaignBid = nativeAdsCampaignBid;
    this.multimediaAdsCampaignBid = multimediaAdsCampaignBid;
    this.multimediaAdsAdgroupBid = multimediaAdsAdgroupBid;
    this.isNativeAdsRebrandingEnabled = pageContext.Permissions.IsNativeAdsRebrandingEnabled;
    this.isMultiMediaAdsEnabled = pageContext.Permissions.IsMultiMediaAdsEnabled;
    this.timeZone = TimeZone;
    this.model = model;
    this.campaignType = pageContext.CurrentCampaign ? currentCampaignType() : campaignType;
    this.campaignSubType = campaignSubType;
    this.collapseAdvancedSettings = collapseAdvancedSettings;
    this.isNewUI = config.get('IsNewUI');
    this.activityLogger = activityLogger;
    this.campaignAdScheduleUseSearcherTimeZone = campaignAdScheduleUseSearcherTimeZone;
    this.supportCashbackSettings = supportCashbackSettings;
    this.isMSStoreAdsGAWorkflow = isMSStoreAdsGAWorkflow;
    this.popupIds = _.defaults({}, popupIds, defaultPopupIds);
    this.newI18n = newI18n;

    this.editMode = !_.isEmpty(this.model);
    const entityType = this.level ? this.level.toLowerCase() : '';

    let isFinalURLSuffixEnabled = false;
    const finalUrlSuffixEnabledEntities = ['campaign', 'adgroup', 'keyword', 'ad', 'audience'];
    // to be conversative, enabling to only these two extensions known to use the advanced URL.
    const finalUrlSuffixPhase3EnabledEntities = ['imageadextension', 'sitelink2adextension'];

    if (finalUrlSuffixEnabledEntities.indexOf(entityType) >= 0) {
      isFinalURLSuffixEnabled = true;
    } else if (finalUrlSuffixPhase3EnabledEntities.indexOf(entityType) >= 0) {
      isFinalURLSuffixEnabled = pageContext.Permissions.IsFinalURLSuffixPhase3Enabled;
    }

    this.viewmodel = new ViewModel({
      scenarioToSectionsMap,
      scenario,
      level: this.level,
      campaignType: this.campaignType,
      isFinalURLSuffixEnabled,
      collapseAdvancedSettings,
      isMSStoreAdsGAWorkflow: this.isMSStoreAdsGAWorkflow,
      model: this.model,
      activityLogger: this.activityLogger,
    });

    this.subViews = {};

    if (this.viewmodel.showAdRotation()) {
      const biddingScheme = _.result(_.result(this.model, 'BiddingScheme'), 'Type');
      const disableRotationOptions = (biddingScheme === 'InheritFromParent') &&
        _.contains(['MaxClicks', 'MaxConversions', 'TargetCpa'], campaignBiddingStrategy);

      this.adRotationView = new AdRotationView(_.result(_.result(this.model, 'AdRotation'), 'RotationType'), disableRotationOptions);
    }

    if (this.viewmodel.showAdDistribution()) {
      this.adDistributionView = new AdDistributionView(
        _.extend(_.defaults(_.pick(this.model, 'AdDistribution', 'Medium', 'Language'), {
          campaignType,
          Language: language,
          campaignSubType,
          activityLogger: this.activityLogger,
          isSPBCampaign,
          isMSStoreAdsGAWorkflow: this.isMSStoreAdsGAWorkflow,
        }), { Languages: languages }));
    }
  }

  setIsSponsoredCampaignCashbackEnabled(isEnabled) {
    if (this.adDistributionView) {
      this.adDistributionView.setIsSponsoredCampaignCashbackEnabled(isEnabled);
    }
  }

  updateLocationTargetsVisibility(entities) {
    if (!_.contains(scenarioToSectionsMap[this.scenario], 'LocationTargets')) {
      this.viewmodel.showLocationTargets(false);
      return;
    }
    const includedLocations = _.filter(entities, (entity) => {
      return entity.SelectionStatus === locationTargetTypes.Included;
    });

    this.viewmodel.showLocationTargets(includedLocations.length > 0);
  }

  updateLocationTargetsInfoText(entities) {
    if (entities.length > 0) {
      this.viewmodel.infoTextLocationTargets('');
    } else {
      this.viewmodel.infoTextLocationTargets(i18n.get('LocationTargeting_TargetEverywhere'));
    }
  }

  onSelectedBidStrategyChange(value) {
    this.viewmodel.biddingScheme(value);
  }

  render() {
    this.$el.html(tmpl({
      i18n,
      title: this.title,
      level: this.level,
      isNotAudienceCampaign: this.isNotAudienceCampaign(),
      isNativeAdsRebrandingEnabled: this.isNativeAdsRebrandingEnabled,
      isMultiMediaAdsEnabled: this.isMultiMediaAdsEnabled,
      isNewUI: this.isNewUI,
      isMSStoreAdsGAWorkflow: this.isMSStoreAdsGAWorkflow,
      popupIds: this.popupIds,
    }));
    ko.applyBindings(this.viewmodel, this.el);

    this.loadAndRenderTargets();
    this.renderLocationTargets();
    this.loadAndRenderAdSchedule();
    this.loadAndRenderNativeAds();
    this.renderUpgradedUrlOptions();
    this.renderVanityUrlSettings();
    this.loadAndRenderExclusions();
    this.renderOtherSettings();

    if (this.editMode && !this.collapseAdvancedSettings) {
      this.$('#setAdvancedSettings').collapse('show');

      if (this.isNewUI) {
        this.$('#setExclusions').collapse('show');
      }
    }

    if (!this.isNotAudienceCampaign()) {
      jsdata.Intermediate.subscribe('CampaignCriterion', () => {
        if (this.level === 'campaign') {
          this.updateLocationTargetsVisibility(jsdata.Intermediate.getAll('CampaignCriterion'));
        }
      });
    }

    return this;
  }

  get title() {
    const isExperiment = _.result(pageContext.CurrentCampaign, 'ExperimentId') > 0;

    if (this.level === 'campaign' && isExperiment) {
      return i18n.get('Section_Advanced_ExperimentSettings');
    } else if (this.level === 'campaign' && !isExperiment) {
      return i18n.get('Targeting_AdvancedOptions_AdvancedCampaignSettings');
    } else {
      return i18n.get('Targeting_AdvancedOptions_AdvancedAdgroupSettings');
    }
  }

  get events() {
    return {
      'show.bs.collapse': 'showAdvancedSettings',
      'hide.bs.collapse': 'hideAdvancedSettings',
    };
  }

  showAdvancedSettings(e) {
    const sectionName = $(e.target).data('section');

    if (sectionName === 'Advanced') {
      this.viewmodel.isAdvancedSettingsExpanded(true);
    } else if (this.isNewUI && sectionName === 'ExclusionsSection') {
      this.viewmodel.isExclusionsExpanded(true);
    } else if (this.activityLogger) {
      this.activityLogger.signal(`show ${sectionName} settings clicked`, 'advanced settings');
    }
  }

  hideAdvancedSettings(e) {
    const sectionName = $(e.target).data('section');

    if (sectionName === 'Advanced') {
      this.viewmodel.isAdvancedSettingsExpanded(false);
    } else if (this.isNewUI && sectionName === 'ExclusionsSection') {
      this.viewmodel.isExclusionsExpanded(false);
    } else if (this.activityLogger) {
      this.activityLogger.signal(`hide ${sectionName} settings clicked`, 'advanced settings');
    }
  }

  loadAndRenderExclusions() {
    if (!this.viewmodel.showSiteExclusion() && !this.viewmodel.showIPExclusion()) {
      return;
    }

    exclusionRepository.load(this.campaignId, this.adgroupId, this.level)
      .then(([campaignExclusions, adgroupExclusions]) => {
        if (this.viewmodel.showSiteExclusion()) {
          const exclusions = this.level === 'campaign' ? campaignExclusions : adgroupExclusions;

          if (this.scenario === 'adgroup-settings' &&
            this.level === 'adgroup' &&
            this.campaignType === 'shopping' &&
            this.campaignSubType === 'ShoppingSponsoredProductAd' &&
            !this.isMSStoreAdsGAWorkflow &&
            _.isEmpty(_.result(exclusions, 'ExcludedSites'))) {
            this.viewmodel.showSiteExclusion(false);
            return;
          }

          this.siteExclusionView = new BaseExclusionView({
            exclusions: _.result(exclusions, 'ExcludedSites'),
            exclusionType: 'site',
            level: this.level,
            campaignExclusions: _.result(campaignExclusions, 'ExcludedSites'),
          });
          this.$('.site-exclusion').empty().append(this.siteExclusionView.render().el);
          this.subViews.SiteExclusion = this.siteExclusionView;
        }

        if (this.viewmodel.showIPExclusion()) {
          this.ipExclusionView = new BaseExclusionView({
            exclusions: _.result(campaignExclusions, 'ExcludedIPs'),
            exclusionType: 'ip',
          });
          this.$('.ip-exclusion').empty().append(this.ipExclusionView.render().el);
          this.subViews.IPExclusion = this.ipExclusionView;
        }
      });
  }

  exclusionsUpdated() {
    if (!this.viewmodel.showSiteExclusion() && !this.viewmodel.showIPExclusion()) {
      return false;
    }

    let siteExclusionsUpdated = this.viewmodel.showSiteExclusion() &&
      this.siteExclusionView &&
      !_.isEqual(this.siteExclusionView.options.exclusions, this.siteExclusionView.getValues());

    let ipExclusionsUpdated = this.viewmodel.showIPExclusion() &&
      this.ipExclusionView &&
      !_.isEqual(this.ipExclusionView.options.exclusions, this.ipExclusionView.getValues());

    return siteExclusionsUpdated || ipExclusionsUpdated;
  }

  saveExtensions() {
    if (!this.viewmodel.showSiteExclusion() && !this.viewmodel.showIPExclusion()) {
      return {};
    }

    const siteExclusions = this.viewmodel.showSiteExclusion() && this.siteExclusionView ? this.siteExclusionView.getValues() : {};
    const ipExclusions = this.viewmodel.showIPExclusion() && this.ipExclusionView ? this.ipExclusionView.getValues() : {};
    let data = {};

    if (this.level === 'campaign') {
      data = {
        campaignId: this.campaignId,
        AdvanceSettings: {
          Exclusions: {
            ExcludedSites: siteExclusions,
            ExcludedIPs: ipExclusions,
          },
        },
      };
    } else {
      data = {
        AdGroupId: this.adgroupId,
        CampaignId: this.campaignId,
        AdvancedSettings: {
          ExcludedSites: siteExclusions,
        },
      };
    }

    return exclusionRepository.saveExtensions(data, this.level)
      .catch((response) => {
        if (response.NegativeSitesResult || response.NegativeIPsResult) {
          this.showExclusionErrors(response);

          throw 'exclusion error'; //eslint-disable-line
        }
      });
  }

  renderOtherSettings() {
    if (pageContext.Permissions.IsMultiMediaAdsEnabled && this.viewmodel.showMultimediaAds()) {
      const multimediaAdsOptions = {
        MultimediaAdTypeMultimediaAdsBidsCampaignBidAdjustment: this.multimediaAdsCampaignBid ? this.multimediaAdsCampaignBid : targetConstants.multimediaAdDefaultBid,
        MultimediaAdTypeMultimediaAdsBidsAdgroupBidAdjustment: this.multimediaAdsAdgroupBid,
      };

      this.multimediaAdsUpdateView = new BaseTargetUpdateView(_.extend({
        targetType: targetTypes.MultimediaAd,
        campaignId: this.campaignId,
        adgroupId: this.adgroupId,
        level: this.level,
        scenario: this.scenario,
        activityLogger: this.activityLogger,
      }, multimediaAdsOptions));
      this.$('.multimedia-ads').empty().html(this.multimediaAdsUpdateView.render().el);

      if (pageContext.Permissions.IsMMAAutomatedCTAOptInEnabled) {
        const callToActionSetting = _.find(this.model.CampaignSettings, (setting) => setting['@odata.type'] === '#Model.CallToActionSetting');

        this.automatedCTAView = new AutomatedCTAView({
          callToActionSetting,
          scenario: this.scenario,
          activityLogger: this.activityLogger,
        });
        this.$('.automated-cta').empty().html(this.automatedCTAView.render().el);
      }
    }

    if (this.viewmodel.showAdRotation()) {
      this.$('.ad-rotation').html(this.adRotationView.render().el);
      this.subViews.AdRotation = this.adRotationView;
    }

    if (this.viewmodel.showAdDistribution()) {
      this.$('.ad-distribution').html(this.adDistributionView.render().el);
      this.subViews.AdDistribution = this.adDistributionView;
    }
  }

  parseSchedulingRows(targets, resetId = false) {
    let schedulingRows = [];

    _.each(targets, (target) => {
      let criterion = target.Criterion;
      let multiplier = target.CriterionBid.Multiplier;
      let cashbackPercent = _.chain(target)
        .result('CriterionCashback')
        .result('CashbackPercent')
        .value();

      if (cashbackPercent === -1) {
        cashbackPercent = null;
      }

      if (cashbackPercent != null) {
        cashbackPercent = decimal.fromFloatToString(cashbackPercent, 2);
      }

      schedulingRows.push({
        Id: resetId ? '' : target.Id,
        Day: criterion.Day,
        StartHour: criterion.FromHour,
        StartMinute: criterion.FromMinute,
        EndHour: criterion.ToHour,
        EndMinute: criterion.ToMinute,
        BidAdjustmentType: multiplier < 0 ? -1 : 1,
        BidAdjustmentAmount: window.Math.abs(multiplier),
        CashbackPercent: cashbackPercent,
      });
    });

    return schedulingRows;
  }

  loadAndRenderAdSchedule() {
    if (!this.campaignId) {
      this.renderAdShedule();
      return;
    }

    if (this.scenario === 'smart-shopping-campaign') {
      return;
    }

    if (this.level === 'campaign') {
      criterionLoader.load(this.campaignId, '', ['DayTimeCriterion'])
        .then((campaignTargets) => {
          let schedulingRows = this.parseSchedulingRows(campaignTargets, this.scenario === 'adgroup-create');

          this.renderAdShedule(schedulingRows);
        });
    } else if (this.level === 'adgroup' && (this.scenario === 'adgroup-settings' || this.scenario === 'adgroup-create')) {
      Promise.join(
        criterionLoader.load(this.campaignId, '', ['DayTimeCriterion']),
        this.scenario === 'adgroup-create' ? Promise.resolve() : criterionLoader.load(this.campaignId, this.adgroupId, ['DayTimeCriterion']),
        (campaignTargets, adgroupTargets) => {
          let schedulingRows = this.parseSchedulingRows(adgroupTargets, false);
          let campaignSchedulingRows = this.parseSchedulingRows(campaignTargets, true);

          this.renderAdShedule(schedulingRows, campaignSchedulingRows);
        },
      );
    } else {
      this.renderAdShedule([]);
    }
  }

  renderAdShedule(schedulingRows = [], campaignSchedulingRows = []) {
    //rendering ad schedule
    if (this.viewmodel.showAdSchedule()) {
      let model = {
        dayTimeRanges: schedulingRows,
        timeZone: this.timeZone,
        adScheduleTimeZoneSetting: this.model.AdScheduleTimeZoneSetting,
        adScheduleUseSearcherTimeZone: this.model.AdScheduleUseSearcherTimeZone,
        startDate: _.result(this.model, 'StartDate'),
        endDate: _.result(this.model, 'EndDate'),
        adGroupStatus: _.result(this.model, 'Status'),
      };

      this.adScheduleView = new AdScheduleView({
        model,
        level: this.level,
        showDateSettings: this.viewmodel.showDateSettings(),
        campaignDayTimeRanges: campaignSchedulingRows,
        campaignAdScheduleUseSearcherTimeZone: this.campaignAdScheduleUseSearcherTimeZone,
        activityLogger: this.activityLogger,
        supportCashbackSettings: this.supportCashbackSettings,
        popupIds: this.popupIds,
      });

      this.$('.ad-schedule').append(this.adScheduleView.render().el);
      this.subViews.AdSchedule = this.adScheduleView;
    }
  }

  renderUpgradedUrlOptions() {
    if (this.viewmodel.showUrlOptions()) {
      this.upgradedUrlOptions = new UpgradedUrlOptions({
        editMode: this.editMode,
        entityType: this.level,
        trackingTemplate: _.result(this.model, 'TrackingUrlTemplate'),
        finalUrlSuffix: _.result(this.model, 'FinalUrlSuffix'),
        customParameters: _.isEmpty(this.model.UrlCustomParameters) ? undefined : this.model.UrlCustomParameters,
        urlOptionsTemplate,
        isNewUI: this.isNewUI,
        showUurlTestTool: this.campaignType !== 'shopping' && (this.level === 'campaign' || this.level === 'adgroup'),
        campaignId: this.campaignId,
        adGroupId: this.adgroupId,
      });

      this.$('.upgraded-url-options-settings').empty().html(this.upgradedUrlOptions.render().el);

      this.subViews.UrlOptions = this.upgradedUrlOptions;
    }
  }

  renderVanityUrlSettings() {
    if (this.viewmodel.showVanityUrlSettings()) {
      ReactDOM.unmountComponentAtNode(this.$('.vanity-url-option').get(0));

      const props = {
        i18n: this.newI18n,
        vanityUrlSettings: this.viewmodel.vanityUrlSettings(),
        onChange: (settings) => this.viewmodel.vanityUrlSettings(settings),
      };

      ReactDOM.render(React.createElement(VanityUrlOption, props, null),
        this.$('.vanity-url-option').get(0),
      );
    }
  }

  setData(payload) {
    const resourceName = this.level === 'adgroup' ? 'AdGroupCriterions' : 'CampaignCriterions';

    if (!payload) {
      return;
    }

    // Fill back the data to the view;
    if (this.adScheduleView) {
      this.adScheduleView.backFillItems(payload.entity ? payload : { entity: payload });
    }

    let resources = [];

    if (_.has(payload, 'entity') && _.has(payload.entity, resourceName)) {
      resources = payload.entity[resourceName];
    } else if (_.has(payload, resourceName)) {
      resources = payload[resourceName];
    }
    _.each(resources, (criterion) => {

      switch (criterion.CriterionType) {
      case targetTypes.Device:
      case targetTypes.OrignalDevice:
        if (this.deviceTargetsUpdateView) {
          this.deviceTargetsUpdateView.setData(criterion);
        }
        break;
      case targetTypes.Age:
        if (this.ageTargetsUpdateView) {
          this.ageTargetsUpdateView.setData(criterion);
        }
        break;
      case targetTypes.Gender:
        if (this.genderTargetsUpdateView) {
          this.genderTargetsUpdateView.setData(criterion);
        }
        break;
      default:
        break;
      }
    });
  }

  getDeviceTypeOptions(campaignBids = {}, adgroupBids = {}) {
    const deviceKeys = targetConstants.rowKeys.Device.concat(['Computers']);

    if (pageContext.Permissions.IsOriginalDeviceTargetingEnabled) {
      _.each(deviceKeys, (device) => {
        _.each(targetConstants.osNames[device], (os) => {
          deviceKeys.push(`${device}${os}`);
        });
      });
    }

    let deviceTypeOptions = {};

    _.each(deviceKeys, (device) => {
      deviceTypeOptions[`DeviceType${device}CampaignBidAdjustment`] = campaignBids[`Device${device}Bid`] || 0;
      deviceTypeOptions[`DeviceType${device}CampaignBidId`] = campaignBids[`Device${device}BidId`] || '';
      deviceTypeOptions[`DeviceType${device}AdgroupBidAdjustment`] = adgroupBids[`Device${device}Bid`] || 0;
      deviceTypeOptions[`DeviceType${device}AdgroupBidId`] = adgroupBids[`Device${device}BidId`] || '';

      if (pageContext.Permissions.IsPersonalizedOffersEnabled) {
        const campaignCashbackPercent = campaignBids[`Device${device}CashbackPercent`];

        deviceTypeOptions[`DeviceType${device}CampaignCashbackPercent`] = campaignCashbackPercent == null ?
          campaignCashbackPercent : decimal.fromFloatToString(campaignCashbackPercent, 2);

        const adgroupCashbackPercent = adgroupBids[`Device${device}CashbackPercent`];

        deviceTypeOptions[`DeviceType${device}AdgroupCashbackPercent`] = adgroupCashbackPercent == null ?
          adgroupCashbackPercent : decimal.fromFloatToString(adgroupBids[`Device${device}CashbackPercent`], 2);
      }
    });
    return deviceTypeOptions;
  }

  getAgeTypeOptions(campaignBids = {}, adgroupBids = {}) {
    const ageKeys = targetConstants.rowKeys.Age;
    let ageBucketsOptions = {};

    _.each(ageKeys, (bucket) => {
      ageBucketsOptions[`AgeType${bucket}CampaignBidAdjustment`] = campaignBids[`Age${bucket}Bid`] || 0;
      ageBucketsOptions[`AgeType${bucket}CampaignBidId`] = campaignBids[`Age${bucket}BidId`] || '';
      ageBucketsOptions[`AgeType${bucket}AdgroupBidAdjustment`] = adgroupBids[`Age${bucket}Bid`] || 0;
      ageBucketsOptions[`AgeType${bucket}AdgroupBidId`] = adgroupBids[`Age${bucket}BidId`] || '';
    });
    return ageBucketsOptions;
  }

  getGenderTypeOptions(campaignBids = {}, adgroupBids = {}) {
    const genderKeys = targetConstants.rowKeys.Gender;
    let genderTypeOptions = {};

    _.each(genderKeys, (gender) => {
      genderTypeOptions[`GenderType${gender}CampaignBidAdjustment`] = campaignBids[`Gender${gender}Bid`] || 0;
      genderTypeOptions[`GenderType${gender}CampaignBidId`] = campaignBids[`Gender${gender}BidId`] || '';
      genderTypeOptions[`GenderType${gender}AdgroupBidAdjustment`] = adgroupBids[`Gender${gender}Bid`] || 0;
      genderTypeOptions[`GenderType${gender}AdgroupBidId`] = adgroupBids[`Gender${gender}BidId`] || '';
    });
    return genderTypeOptions;
  }

  isNotAudienceCampaign() {
    return this.campaignType !== 'audience';
  }

  renderTargets(campaignBids = {}, adgroupBids = {}) {
    //rendering device targets
    if (this.viewmodel.showDeviceTargets()) {
      let deviceTypeOptions = this.getDeviceTypeOptions(campaignBids, adgroupBids);

      this.deviceTargetsUpdateView = new BaseTargetUpdateView(_.extend({
        targetType: pageContext.Permissions.IsOriginalDeviceTargetingEnabled ? targetTypes.OriginalDevice : targetTypes.Device,
        campaignId: this.campaignId,
        adgroupId: this.adgroupId,
        level: this.level,
        scenario: this.scenario,
        activityLogger: this.activityLogger,
        supportCashbackSettings: this.supportCashbackSettings,
      }, deviceTypeOptions));
      this.$('.device-targets').append(this.deviceTargetsUpdateView.render().el);

      this.subViews.DeviceTargets = this.deviceTargetsUpdateView;
    }

    //rendering age targets
    if (this.viewmodel.showAgeTargets()) {
      let ageBucketsOptions = this.getAgeTypeOptions(campaignBids, adgroupBids);

      this.ageTargetsUpdateView = new BaseTargetUpdateView(_.extend({
        targetType: targetTypes.Age,
        campaignId: this.campaignId,
        adgroupId: this.adgroupId,
        level: this.level,
        scenario: this.scenario,
        activityLogger: this.activityLogger,
      }, ageBucketsOptions));
      this.$('.demographic-age-targets').append(this.ageTargetsUpdateView.render().el);

      this.subViews.AgeTargets = this.ageTargetsUpdateView;
    }

    //rendering gender targets
    if (this.viewmodel.showGenderTargets()) {
      let genderTypeOptions = this.getGenderTypeOptions(campaignBids, adgroupBids);

      this.genderTargetsUpdateView = new BaseTargetUpdateView(_.extend({
        targetType: targetTypes.Gender,
        campaignId: this.campaignId,
        adgroupId: this.adgroupId,
        level: this.level,
        scenario: this.scenario,
        activityLogger: this.activityLogger,
      }, genderTypeOptions));
      this.$('.demographic-gender-targets').append(this.genderTargetsUpdateView.render().el);

      this.subViews.GenderTargets = this.genderTargetsUpdateView;
    }
  }

  loadAndRenderTargets() {
    // Do not show targeting section when pilot enabled
    // Ad Schedule settings would become an independent section
    // Device and Demographic settings would be moved to Campaign targets
    if (this.isNotAudienceCampaign()) {
      return;
    }
    //if no campaignId is present (in case of campaign-create), then only render (with empty data)
    if (!this.campaignId) {
      this.renderTargets();
      return;
    }
    if (this.scenario === 'smart-shopping-campaign') {
      return;
    }
    let targetsToLoad = [];

    if (this.viewmodel.showDeviceTargets()) {
      targetsToLoad.push('DeviceCriterion');
    }
    if (this.viewmodel.showAgeTargets()) {
      targetsToLoad.push('AgeCriterion');
    }
    if (this.viewmodel.showGenderTargets()) {
      targetsToLoad.push('GenderCriterion');
    }
    if (this.level === 'campaign' || this.scenario === 'adgroup-create') {
      criterionLoader.load(this.campaignId, '', targetsToLoad)
        .then((campaignTargets) => {
          let campaignBids = this.extractBids(campaignTargets);

          this.renderTargets(campaignBids);
        });
    } else if (this.level === 'adgroup') {
      Promise.join(
        criterionLoader.load(this.campaignId, '', targetsToLoad),
        criterionLoader.load(this.campaignId, this.adgroupId, targetsToLoad),
        (campaignTargets, adgroupTargets) => {
          let campaignBids = this.extractBids(campaignTargets);
          let adgroupBids = this.extractBids(adgroupTargets);

          this.renderTargets(campaignBids, adgroupBids);
        },
      );
    }
  }

  renderNativeAds(campaignBids = {}, adgroupBids = {}) {
    if (this.viewmodel.showNativeAds()) {
      const nativeAdsOptions = {
        NativeAdTypeNativeAdsBidsCampaignBidAdjustment: campaignBids.NativeAdBid,
        NativeAdTypeNativeAdsBidsAdgroupBidAdjustment: adgroupBids.NativeAdBid,
      };

      // if (pageContext.Permissions.IsPersonalizedOffersEnabled) {
      //   nativeAdsOptions.NativeAdTypeNativeAdsBidsCampaignCashbackPercent = campaignBids.NativeAdTypeNativeAdsBidsCashbackPercent;
      //   nativeAdsOptions.NativeAdTypeNativeAdsBidsAdgroupCashbackPercent = adgroupBids.NativeAdTypeNativeAdsBidsCashbackPercent;
      // }

      this.nativeAdsUpdateView = new BaseTargetUpdateView(_.extend({
        targetType: targetTypes.NativeAd,
        campaignId: this.campaignId,
        adgroupId: this.adgroupId,
        level: this.level,
        scenario: this.scenario,
        activityLogger: this.activityLogger,
        // supportCashbackSettings: this.supportCashbackSettings,
      }, nativeAdsOptions));
      this.$('.native-ads').empty().html(this.nativeAdsUpdateView.render().el);

      this.subViews.NativeAds = this.nativeAdsUpdateView;
    }
  }

  loadAndRenderNativeAds() {
    let campaignBids = {
      NativeAdBid: this.nativeAdsCampaignBid,
    };
    let adgroupBids = {
      NativeAdBid: this.nativeAdsAdgroupBid,
    };

    this.renderNativeAds(campaignBids, adgroupBids);
  }

  renderLocationTargets() {
    if (this.viewmodel.showLocationTargets() && this.level === 'campaign') {
      this.locationTargetsView = new LocationTargetBidView({
        level: this.level,
      });

      if (!this.isNotAudienceCampaign()) {
        this.$('.location-targets').empty().html(this.locationTargetsView.render().el);
      }

      this.subViews.LocationTargets = this.locationTargetsView;
    }
  }

  update(language) {
    if (this.locationTargetsView) {
      this.locationTargetsView.refresh();
    }

    if (this.adDistributionView && !_.isEmpty(language)) {
      this.adDistributionView.update(language);
    }
  }

  extractBids(targets) {
    let bids = {};

    _.each(targets, (target) => {
      let prefix = `${target.Criterion.Type}${target.Criterion[targetConstants.targetTypeToFilterProperty[target.Criterion.Type]]}`;

      if (target.Criterion.Type === 'Device' && target.Criterion.OSName) {
        prefix += target.Criterion.OSName;
      }
      const name = `${prefix}Bid`;
      const id = `${name}Id`;

      bids[name] = target.CriterionBid ? target.CriterionBid.Multiplier : 0;
      bids[id] = target.Id || '';

      const cashbackName = `${prefix}CashbackPercent`;

      bids[cashbackName] = target.CriterionCashback ? target.CriterionCashback.CashbackPercent : '';
    });
    return bids;
  }

  getValues(adgroupName, campaignName) {
    const deletedDayTimeCb = (deletedDayTimeCriterions) => {
      if (this.scenario === 'adgroup-create') {
        _.each(deletedDayTimeCriterions, (criterion) => {
          criterion.Status = 'Deleted';
          criterion.CampaignName = campaignName;
          criterion.AdGroupName = adgroupName;
        });
      } else if (this.level === 'adgroup') {
        _.each(deletedDayTimeCriterions, (criterion) => {
          criterion.Status = 'Deleted';
          criterion.AdGroup = {
            Id: pageContext.CurrentAdGroup.Id,
          };
        });
      } else {
        const currentCampaignId = _.isEmpty(pageContext.CurrentCampaign) ? this.campaignId : pageContext.CurrentCampaign.Id;

        _.each(deletedDayTimeCriterions, (criterion) => {
          criterion.Status = 'Deleted';
          criterion.Campaign = {
            Id: currentCampaignId,
          };
        });
      }
    };

    let urlOptions = {};

    if (this.viewmodel.showUrlOptions()) {
      urlOptions = this.upgradedUrlOptions.toObject();
      if (_.isEmpty(urlOptions.TrackingUrlTemplate)) {
        urlOptions.TrackingUrlTemplate = null;
      }
      if (_.isEmpty(urlOptions.UrlCustomParameters)) {
        urlOptions.UrlCustomParameters = null;
      }
    }

    let values = {
      deviceTargets: this.deviceTargetsUpdateView ? this.deviceTargetsUpdateView.getValues() : [],
      ageTargets: this.ageTargetsUpdateView ? this.ageTargetsUpdateView.getValues() : [],
      genderTargets: this.genderTargetsUpdateView ? this.genderTargetsUpdateView.getValues() : [],
      locationTargets: this.locationTargetsView ? this.locationTargetsView.getValues() : [],
      nativeAds: this.nativeAdsUpdateView ? this.nativeAdsUpdateView.getValues() : {},
      multimediaAds: this.multimediaAdsUpdateView ? this.multimediaAdsUpdateView.getValues() : {},
      automatedCTA: this.automatedCTAView ? this.automatedCTAView.getValues() : {},
      scheduling: this.adScheduleView ? this.adScheduleView.getValues(deletedDayTimeCb) : [],
      dateSettings: this.adScheduleView ? this.adScheduleView.getDateSettings() : {},
      urlOptions,
      adRotation: this.viewmodel.showAdRotation() ? this.adRotationView.getValues() : {},
      netWorkOptions: this.viewmodel.showAdDistribution() ? this.adDistributionView.toObject() : {},
      siteExclusions: this.viewmodel.showSiteExclusion() && this.siteExclusionView ? this.siteExclusionView.getValues() : [],
      ipExclusions: this.viewmodel.showIPExclusion() && this.ipExclusionView ? this.ipExclusionView.getValues() : [],
    };

    if (this.adScheduleView && this.adScheduleView.getAdScheduleUseSearcherTimeZone) {
      values.adScheduleUseSearcherTimeZone = this.adScheduleView.getAdScheduleUseSearcherTimeZone();
    }

    if (this.viewmodel.showVanityUrlSettings()) {
      values.vanityUrlSettings = this.viewmodel.vanityUrlSettings();
    }

    if (this.scenario === 'adgroup-create') {
      values.deviceTargets = _.map(values.deviceTargets, (deviceTarget) => {
        return _.extend(deviceTarget, {
          'CampaignName': campaignName,
          'AdGroupName': adgroupName,
        });
      });

      values.scheduling = _.map(values.scheduling, (row) => {
        return _.extend(row, {
          'CampaignName': campaignName,
          'AdGroupName': adgroupName,
        });
      });
    }

    if (this.viewmodel.showSearchCampaignPredictiveMatching()) {
      values.AutoTargetingEnabled = this.viewmodel.predictiveMatchingChecked();
    }

    return values;
  }

  showExclusionErrors({ NegativeSitesResult: siteErrors, NegativeIPsResult: ipErrors }) {
    if (this.viewmodel.showSiteExclusion() && this.siteExclusionView) {
      this.siteExclusionView.showErrors(siteErrors);
    }

    if (this.viewmodel.showIPExclusion() && this.ipExclusionView) {
      this.ipExclusionView.showErrors(ipErrors);
    }
    this.$('#setAdvancedSettings').collapse('show');

    if (this.isNewUI) {
      this.$('#setExclusions').collapse('show');
    }
  }

  validate() {
    const allValid = _.chain(this.subViews)
      .map((view, section) => {
        const isValid = !_.isFunction(view.validate) || view.validate();

        if (!isValid) {
          this.$(`#set${section}Settings`).collapse('show');
        }
        if (!isValid && _.contains(['AgeTargets', 'GenderTargets'], section)) {
          this.$('#setDemographicTargetsSettings').collapse('show');
        }
        if (!isValid && section === 'UrlOptions') {
          view.expandSettingsWithValidateErrors();
        }
        return isValid;
      })
      .every()
      .value();

    if (!allValid) {
      this.$('#setAdvancedSettings').collapse('show');

      if (this.isNewUI) {
        this.$('#setExclusions').collapse('show');
      }
    }

    return allValid;
  }

  clearApiErrors() {
    _.each(this.subViews, (view) => {
      if (_.isFunction(view.clearApiErrors)) {
        view.clearApiErrors();
      }
    });
  }

  handleErrors(response) {
    this.expandSettingsWithErrors(response);
    _.each(this.subViews, (view) => {
      if (_.isFunction(view.handleErrors)) {
        response.errors = view.handleErrors(response);
      }
    });

    if (response.entity.errors) {
      if (this.viewmodel.showUrlOptions()) {
        this.upgradedUrlOptions.handleApiErrors(_.groupBy(response.entity.errors, 'property'));
        response.errors = _.reject(response.errors, (err) => {
          return err.Property === 'TrackingUrlTemplate' || err.Property === 'UrlCustomParameters';
        });
      }
    }

    return response.errors;
  }

  expandSettingsWithErrors(response) {
    let errors = response.errors;
    let locationTargetsHaveErrors = _.some(_.filter(errors, (err) => {
      return err.Type.indexOf('Location Criterion') > -1;
    }));
    let deviceTargetsHaveErrors = _.some(_.filter(errors, (err) => {
      return err.Type.indexOf('DeviceOS Criterion') > -1;
    }));
    let demographicHaveErrors = _.some(_.filter(errors, (err) => {
      return err.Type.indexOf('Age Criterion') > -1 || err.Type.indexOf('Gender Criterion') > -1;
    }));
    let adScheduleHaveErrors = _.some(_.filter(errors, (err) => {
      return err.Type.indexOf('Day Time Criterion') > -1;
    }));
    let properties = _.groupBy(response.entity.errors, 'property');
    let urlOptionsHaveErrors = _.has(properties, 'TrackingUrlTemplate') || _.has(properties, 'UrlCustomParameters') || _.has(properties, 'FinalUrlSuffix');

    if (locationTargetsHaveErrors) {
      this.$('#setLocationTargetsSettings').collapse('show');
    }
    if (deviceTargetsHaveErrors) {
      this.$('#setDeviceTargetsSettings').collapse('show');
    }
    if (demographicHaveErrors) {
      this.$('#setDemographicTargetsSettings').collapse('show');
    }
    if (adScheduleHaveErrors) {
      this.$('#setAdScheduleSettings').collapse('show');
    }
    if (urlOptionsHaveErrors) {
      this.upgradedUrlOptions.expandSettingsWithApiErrors(_.has(properties, 'TrackingUrlTemplate'), _.has(properties, 'UrlCustomParameters'), _.has(properties, 'FinalUrlSuffix'));
    }

    if (locationTargetsHaveErrors || deviceTargetsHaveErrors || demographicHaveErrors || adScheduleHaveErrors || urlOptionsHaveErrors) {
      this.$('#setAdvancedSettings').collapse('show');
    }
  }

  setAdGroupId(adgroupId) {
    this.adgroupId = adgroupId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }

  setLevel(level) {
    this.level = level;

    if (this.viewmodel.showDeviceTargets() && this.deviceTargetsUpdateView) {
      this.deviceTargetsUpdateView.setLevel(level);
    }

    if (this.viewmodel.showAgeTargets() && this.ageTargetsUpdateView) {
      this.ageTargetsUpdateView.setLevel(level);
    }

    if (this.viewmodel.showGenderTargets() && this.genderTargetsUpdateView) {
      this.genderTargetsUpdateView.setLevel(level);
    }
  }

  remove() {
    _.each(this.subViews, (view) => {
      view.remove();
    });

    if (this.viewmodel.showVanityUrlSettings()) {
      ReactDOM.unmountComponentAtNode(this.$('.vanity-url-option').get(0));
    }

    super.remove();
  }
}
